import { Injectable } from '@angular/core';
import { ReportReservedParameter } from '../models';
import { Store } from '@ngxs/store';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { environment } from '@environments/environment';
import { TenantModel } from '@core/models/auth/tenant.model';

@Injectable()
export class ReportsMappingService {
  tenant: TenantModel;
  constructor(private store: Store) {
    this.tenant = this.store.selectSnapshot(AuthState.getTenant);
  }

  mapUserReference(): string {
    const token = this.store.selectSnapshot(AuthState.getDecodedToken);

    if (environment.reportConfig.userReference === 'sub') {
        return token.username;
    } else {
        return token.uid;
    }
}

  mapReservedParameters(reportReservedParameters: ReportReservedParameter[]): string {
    let params = '';

    const token = this.store.selectSnapshot(AuthState.getDecodedToken);

    if (reportReservedParameters && reportReservedParameters.length > 0) {
      if (reportReservedParameters.some((s) => s.name.toUpperCase() === 'USERID')) {
        params += '&UserID=' + token.uid;
      }
      if (reportReservedParameters.some((s) => s.name.toUpperCase() === 'TENANTID')) {
        params += '&TenantId=' + this.tenant.id;
      }
    }

    return params;
  }

  getReservedParameterValue(name: string): string {
    if (name.toUpperCase() === 'USERID') {
      const token = this.store.selectSnapshot(AuthState.getDecodedToken);

      return token.uid;
    } else if (name.toUpperCase() === 'TENANTID') {
      return this.tenant.id;
    }
  }
}
